var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { USDCLogo, WBTCLogo, WETHLogo, YVUSDcLogo, WBNBLogo, BUSDLogo } from "../assets/icons/erc20Assets";
import { Chains } from "../constants/constants";
import colors from "../designSystem/colors";
export var assetFilterList = [
    // "AAVE",
    "WETH",
    // "stETH",
    // "USDC",
    // "WBTC",
    // "WAVAX",
    // "sAVAX",
    // "SOL",
];
export var getIntegralAsset = function (derivative) {
    switch (derivative) {
        // Per design, we only consider USDC.e and USDC the same asset.
        // We consider stETH/ETH, sAVAX/AVAX, and yvUSDC/USDC differet assets.
        /*
        case "stETH":
          return "ETH"
        case "sAVAX":
          return "WAVAX";
        case "yvUSDC":
        */
        // case "USDC.e":
        //   return "USDC";
        default:
            return derivative;
    }
};
export var isYieldAsset = function (asset) {
    switch (asset) {
        // case "sAVAX":
        // case "stETH":
        // case "wstETH":
        // case "yvUSDC":
        //   return true;
        default:
            return false;
    }
};
export var getYieldAssetUnderlying = function (asset) {
    return undefined;
    // switch (asset) {
    //   case "sAVAX":
    //     return "WAVAX";
    //   case "stETH":
    //   case "wstETH":
    //     return "WETH";
    //   case "yvUSDC":
    //     return "USDC";
    // }
};
export var getChainByAsset = function (asset) {
    switch (asset) {
        case "WETH":
        case "WBTC":
        case "USDC":
        case "WBNB":
            return Chains.BSC;
        // case "SOL":
        //   return Chains.Solana;
        // case "WAVAX":
        // case "sAVAX":
        // case "USDC.e":
        //   return Chains.Avalanche;
        default:
            return Chains.Ethereum;
    }
};
export var getChainByVaultOption = function (vault) {
    switch (vault) {
        // case "bBUSD-ETH-P-THETA":
        // case "bETH-THETA":
        // case "bBTC-THETA":
        case "bBNB-THETA":
            return Chains.BSC;
        // case "ryvUSDC-ETH-P-THETA":
        // case "rstETH-THETA":
        // case "rAAVE-THETA":
        // case "rAPE-THETA":
        //   return Chains.Ethereum;
        // case "rAVAX-THETA":
        // case "rsAVAX-THETA":
        // case "rBUSD-AVAX-P-THETA":
        //   return Chains.Avalanche;
        // case "rSOL-THETA":
        //   return Chains.Solana;
        default:
            return Chains.NotSelected;
    }
};
export var getAssetDisplay = function (asset) {
    switch (asset) {
        case "WETH":
            return "ETH";
        // case "WAVAX":
        //   return "AVAX";
        case "WBTC":
            return "BTC";
        case "USDC":
            return "BUSD";
        default:
            return asset;
    }
};
export var getAssetDecimals = function (asset) {
    switch (asset) {
        // case "WBTC":
        //   return 8;
        // case "USDC":
        // case "USDC.e":
        // case "yvUSDC":
        //   return 6;
        case "WBTC":
            return 18;
        case "USDC":
            return 18;
        case "WBNB":
            return 18;
        // case "SOL":
        //   return 9;
        default:
            return 18;
    }
};
export var getDefaultSignificantDecimalsFromAssetDecimals = function (decimals) {
    switch (decimals) {
        case 18:
            return 6;
        case 8:
            return 5;
        case 9:
            return 4;
        case 6:
        default:
            return 2;
    }
};
export var getAssetDefaultSignificantDecimals = function (asset) {
    return getDefaultSignificantDecimalsFromAssetDecimals(getAssetDecimals(asset));
};
export var getAssetColor = function (asset) { return colors.asset[asset]; };
export var getWalletColor = function (wallet) {
    return colors.wallets[wallet];
};
var ColoredWBTCLogo = styled(WBTCLogo)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  && * {\n    fill: ", ";\n  }\n"], ["\n  width: 100%;\n  && * {\n    fill: ", ";\n  }\n"])), colors.asset.WBTC);
var ColoredUSDCLogo = styled(USDCLogo)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"], ["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"])), function (props) {
    return props.backgroundColor ? props.backgroundColor : colors.asset.USDC + "29";
}, colors.asset.USDC);
var ColoredYVUSDCLogo = styled(YVUSDcLogo)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"], ["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"])), function (props) {
    return props.backgroundColor ? props.backgroundColor : colors.asset.USDC + "29";
}, colors.asset.USDC);
var DefaultLogo = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 42px;\n  height: 42px;\n  background: url(/apple-touch-icon.png) no-repeat;\n  background-size: cover;\n"], ["\n  width: 42px;\n  height: 42px;\n  background: url(/apple-touch-icon.png) no-repeat;\n  background-size: cover;\n"])));
export var LidoThemedETHLogo = styled(WETHLogo)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  path {\n    fill: ", ";\n  }\n"], ["\n  path {\n    fill: ", ";\n  }\n"])), colors.asset.stETH);
export var getAssetLogo = function (asset) {
    switch (asset) {
        // case "USDC":
        // case "USDC.e":
        //   return ColoredUSDCLogo;
        case "WBTC":
            return ColoredWBTCLogo;
        case "WETH":
        case "ETH":
            return WETHLogo;
        case "USDC":
            return BUSDLogo;
        case "WBNB":
            return WBNBLogo;
        // case "BNB":
        //   return BNBLOGO;
        // case "yvUSDC":
        //   return ColoredYVUSDCLogo;
        // case "stETH":
        // case "wstETH":
        //   return STETHLogo;
        // case "AAVE":
        //   return AAVELogo;
        // case "WAVAX":
        //   return WAVAXLogo;
        // case "sAVAX":
        //   return SAVAXLogo;
        // case "PERP":
        //   return PERPLogo;
        // case "SOL":
        //   return SolanaLogo;
        // case "APE":
        //   return APELogo;
        // case "WBNB":
        //   return WBNBLogo;
        default:
            return DefaultLogo;
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=asset.js.map